import { render, staticRenderFns } from "./DashboardSessionStatsItem.vue?vue&type=template&id=664bb49e"
import script from "./DashboardSessionStatsItem.vue?vue&type=script&lang=js"
export * from "./DashboardSessionStatsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664bb49e')) {
      api.createRecord('664bb49e', component.options)
    } else {
      api.reload('664bb49e', component.options)
    }
    module.hot.accept("./DashboardSessionStatsItem.vue?vue&type=template&id=664bb49e", function () {
      api.rerender('664bb49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/DashboardSessionStatsItem.vue"
export default component.exports